import type { CanvasJSON } from '../types';
import { withCrossOrigin } from '../../export/utils/canvas-json';
import { hydrateSvgUrlsInJson } from '../../svg-import';
import { deriveImageBoxes } from './derive-image-boxes';

/** Transformations applied to the JSON before `loadFromJSON`. */
export async function prepareCanvasJson(json: CanvasJSON): Promise<CanvasJSON> {
  return hydrateSvgUrlsInJson(withCrossOrigin(deriveImageBoxes(json)));
}
